import { render, staticRenderFns } from "./ProductDetailPage.vue?vue&type=template&id=cd8f86b4&scoped=true"
import script from "./ProductDetailPage.vue?vue&type=script&lang=js"
export * from "./ProductDetailPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/productDetail.scss?vue&type=style&index=0&id=cd8f86b4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8f86b4",
  null
  
)

export default component.exports